export const iconCodes = {
  '01n' : 'Night',
  '01d' : 'Sunny',
  '02n' : 'NightClouds',
  '02d' : 'SunClouds',
  '03n' : 'Clouds',
  '03d' : 'Clouds',
  '04n' : 'DarkClouds',
  '04d' : 'DarkClouds',
  '09n' : 'DarkCloudRain',
  '09d' : 'DarkCloudRain',
  '10n' : 'NightRain',
  '10d' : 'SunRain',
  '11n' : 'Thunder',
  '11d' : 'Thunder',
  '13d' : 'Snow',
  '13n' : 'Snow',
  '50d' : 'Mist',
  '50n' : 'Mist'
};

export const rainData = {
  '09d': '90%',
  '09n': '90%',
  '10d': '70%',
  '10n': '70%',
  '04d': '50%',
  '04n': '50%',
  '03d': '10%',
  '03n': '10%',
  '01n': '0%',
  '01d': '0%',
  '02n': '0%',
  '02d': '0%',
  '11n': '0%',
  '11d': '0%',
  '13d': '0%',
  '13n': '0%',
  '50d': '0%',
  '50n': '0%',
};


export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];